if (!customElements.get('upsell-form')) {
  customElements.define(
    'upsell-form',
    class extends HTMLElement {
      constructor() {
        super();
        this.onSubmit = this.onSubmit.bind(this);
      }

      connectedCallback() {
        this.addEventListener('submit', this.onSubmit);
      }

      onSubmit(event) {
        event.preventDefault();
        const formData = new FormData(event.target);
        const variantId = formData.get('id');
        const quantity = formData.get('quantity') || 1;
        this.addToCart(variantId, quantity);
      }

      addToCart(variantId, quantity) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({ id: variantId, quantity }),
        })
          .then((response) => response.json())
          .then((data) => {
            window.location.href = '/cart';
          })
          .catch((error) => {
            console.error('Error adding item to cart:', error);
          });
      }
    }
  );
}
